import { Component, Input } from '@angular/core'

@Component({
  selector: 'atyl-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss']
})
export class RowComponent {

  @Input() fluid: boolean = false;
  constructor() { }

}
